import { login } from '../auth';
import { showToast } from '../components/toast';

export async function loginPage(): Promise<HTMLElement> {
  const page = document.createElement('div');
  page.className = 'min-h-screen bg-gray-50 flex items-center justify-center p-4';

  page.innerHTML = `
    <div class="w-full max-w-md">
      <div class="text-center mb-8">
        <div class="w-14 h-14 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
        </div>
        <h1 class="text-2xl font-bold text-gray-900">PropCommand</h1>
        <p class="text-gray-500 mt-1">Investment property management</p>
      </div>

      <div class="card" id="login-card">
        <form id="login-form">
          <div class="space-y-4">
            <div>
              <label class="label">Username</label>
              <input name="username" type="text" class="input-field" required placeholder="has" autocomplete="username">
            </div>
            <div>
              <label class="label">Password</label>
              <input name="password" type="password" class="input-field" required placeholder="••••••••" autocomplete="current-password">
            </div>
            <button type="submit" class="btn-primary w-full" id="login-btn">Sign In</button>
          </div>
        </form>

      </div>
    </div>
  `;

  const loginForm = page.querySelector('#login-form') as HTMLFormElement;

  // Login
  loginForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = page.querySelector('#login-btn') as HTMLButtonElement;
    btn.disabled = true;
    btn.textContent = 'Signing in...';
    try {
      const fd = new FormData(loginForm);
      await login(fd.get('username') as string, fd.get('password') as string);
      window.location.hash = '#/dashboard';
    } catch (err: unknown) {
      showToast((err as Error).message || 'Login failed', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = 'Sign In';
    }
  });

  return page;
}
